var Backbone = require('backbone');
var _ = require('underscore');
var $ = require('jquery');

var Radio = require('backbone.radio');
var routerChannel = Radio.channel('router');

var lastMapType = '';

module.exports = Backbone.Router.extend({
	routes: {
		'': 'index',
		'overview': 'overview',
		'map(/:type)(/:id)': 'map',
		'tool(/:type)(/:id)': 'map',// preserve old tool URL
		'rick': 'rickroll',
		'*other':'index'
	},

	index: function() {
		UCS.App.root.showChildView('main', new UCS.App.Index() );
		$('#header').slideUp();
		this.set_pagetitle();
	},
	overview: function() {
		UCS.App.root.showChildView('main', new UCS.App.Overview() );
	},
	map: function(type, id){

		$('#header').slideDown();
		// Default boundary

		if(type === null){ type = 'congressional'; }

		if(type === 'county'){
			if(!id){ id = ''; }
		}else{
			if(id){ id = parseInt(id,10); }else{ id = 0; }
		}


		// make sure null/empty id sets zoomed state to false
		if(!id){
			UCS.App.MapState.set({zoomed: false});
		}

		// Always update current active map type and id
		UCS.App.MapState.set({
			type: type,
			id: id
		});

		var first_run = UCS.App.MapState.get('first_run');
		if(first_run){
			this.tool = new UCS.App.Tool({
				// destroyImmediate: false,
				type: type,
				id: id
			});
			UCS.App.root.showChildView('main',this.tool);
			UCS.App.MapState.set('first_run', false);
		}

		// If already in map tool and it's shown, no need to redraw on each route change

		if(UCS.App.root.main.currentView != this.tool){
			this.tool = new UCS.App.Tool({
				// destroyImmediate: false,
				type: type,
				id: id
			});
			UCS.App.root.showChildView('main', this.tool );
			routerChannel.trigger('map:update:boundary');

			if(id){
				UCS.App.Router.navigate('map/' + type + '/' + id);
			}else {
				UCS.App.Router.navigate('map/' + type);
			}

		} else if (type != lastMapType){
			// Changing Map Boundary
			// Always update current active map type and id

			UCS.App.MapState.set({
				type: type,
				id: id
			});
			routerChannel.trigger('map:update:boundary');
		}

		// cache the previous map type for comparison later
		lastMapType = type;

	},

	rickroll: function(){
		console.warn('ACTIVATING RICK ASTLEY PROTOCOL');
		$('#map_1_svg, #main, .details-layout').css({
			"background": "url(http://i.imgur.com/wPw5lYC.jpg)"
		});
	},

	set_pagetitle: function(){
		document.title = "UC Startups";
	},
});
